import { useContext } from "react";
import { VectorSet2Layout } from "./layout/VectorSet2Layout";
import { ChartSection } from "../../layout/ChartSection";
import { RefProvider } from "./store/RefContext";
import { LayoutProvider } from "./store/LayoutContext";
import { LocalStoreProvider } from "./store/LocalStore";
import { StoreContext } from "../../store/Store";

import { model  } from "../../layout/models/vectorSet2context";

export const VectorSet2 = () => {
  const [store] = useContext(StoreContext);
  const { auth, dimensions } = store;
  

  return auth && model ? (
    <ChartSection header="" height={dimensions.vh}>
      <LayoutProvider model={model}>
        <RefProvider>
          <LocalStoreProvider>
            <VectorSet2Layout />
          </LocalStoreProvider>
        </RefProvider>
      </LayoutProvider>
    </ChartSection>
  ) : null;
};
